<div class="wrapper">
  <button class="multi-option-button" [ngClass]="[styleClass]" [disabled]="disabled" (click)="toggleOptions()">
    @if (showMenuIcon) {
      <img [attr.alt]="'imgAlt.menu.svg' | translate" src="assets/images/menu.svg" />
    }

    {{ text | translate }}

    @if (showArrowDownIcon) {
      <img [attr.alt]="'imgAlt.chevron-down.svg' | translate" src="assets/images/chevron-down.svg" />
    }
  </button>
  <div class="options-overlay" [ngClass]="{ open: isOpen }">
    @for (option of options; track option) {
      <button class="option" (click)="onOptionClick(option)">
        {{ option | translate }}
      </button>
    }
  </div>
</div>
